// extracted by mini-css-extract-plugin
module.exports = {"pdfViewer":"index_pdfViewer__rm0dn"};